var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Leadership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.13 37.68v22.81a3 3 0 11-6 0V37.68a3.93 3.93 0 00-3.92-3.92v29.7H27.45V33.73a3.93 3.93 0 00-3.93 3.92v22.84a3.002 3.002 0 01-4.215 3.152 3.001 3.001 0 01-1.725-3.152V37.65a9.88 9.88 0 019.91-9.83h9.86l-1 25.76 2.05 2.93 2-2.89-1-25.8h9.94a9.87 9.87 0 019.79 9.86zm-15.85-15.1a7.91 7.91 0 10-11.13-1.25 7.891 7.891 0 0011.13 1.25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Leadership.2f403db2.svg";
export { SvgF1Leadership as ReactComponent };